module.exports = "/images/vendor/flag-icon-css/flags/4x3/bj.svg?c81e891543509717b02a594b40afa14a";